"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var BaseUri = require("./Support/BaseUri");
var Request = require("./Support/Request");
function getCategories() {
    var url = BaseUri.compose()
        .segment('categories')
        .toString();
    return Request.getJson(url);
}
exports.getCategories = getCategories;
function getCollections() {
    var url = BaseUri.compose()
        .segment('collections')
        .toString();
    return Request.getJson(url);
}
exports.getCollections = getCollections;
function getCountries() {
    var url = BaseUri.compose('shipping', 'countries')
        .toString();
    return Request.getJson(url);
}
exports.getCountries = getCountries;
function getInstallTemplates() {
    var url = BaseUri.compose('installs', 'templates')
        .toString();
    return Request.getJson(url);
}
exports.getInstallTemplates = getInstallTemplates;
function getRooms() {
    var url = BaseUri.compose('rooms')
        .toString();
    return Request.getJson(url);
}
exports.getRooms = getRooms;
function getRoomSceneCategories() {
    var url = BaseUri.compose('rooms', 'categories')
        .toString();
    return Request.getJson(url);
}
exports.getRoomSceneCategories = getRoomSceneCategories;
function getSite() {
    var url = BaseUri.compose('status')
        .toString();
    return Request.getJson(url);
}
exports.getSite = getSite;
function getTextures() {
    var url = BaseUri.compose('textures')
        .toString();
    return Request.getJson(url);
}
exports.getTextures = getTextures;
function getTrykProducts() {
    var url = BaseUri.compose('tryk', 'products')
        .toString();
    return Request.getJson(url);
}
exports.getTrykProducts = getTrykProducts;
function getYarnLibraries() {
    var url = BaseUri.compose('yarns', 'libraries')
        .toString();
    return Request.getJson(url);
}
exports.getYarnLibraries = getYarnLibraries;
